import React from "react";

// The chevron + title (+ optional count) bar every collapsible row-group in
// the grid uses - extracted after PhaseRowHeader.js (Training/Nutrition
// Phase) and AthleteStatsHeader.js (Tracked Results) were found each
// carrying their own copy of this exact markup, and Fase 5 needed the same
// treatment a third and fourth time (Milestones, Notes). See
// ~/.claude/plans/periodization-calendar-view-redesign.md.
export const CollapsibleSectionTitle = ({
  title,
  badge,
  count,
  subtitle,
  isCollapsed,
  onToggleCollapse,
}) => (
  <div
    role="button"
    className="phase-track-section-title"
    onClick={onToggleCollapse}
  >
    <div className="phase-track-title-group">
      <img
        src="/img/svg/angle-down.svg"
        className={`phase-track-chevron${isCollapsed ? " collapsed" : ""}`}
        alt=""
      />
      <span className="phase-track-title">{title}</span>
      {badge}
    </div>
    <div className="phase-track-subtitle">
      {subtitle ??
        (count != null && <span className="phase-track-count">{count}</span>)}
    </div>
  </div>
);
